import { createFileRoute } from '@tanstack/react-router'

import { BlytzCollectAnalyticsScreen } from './-components/analytics-screen.tsx'

export const Route = createFileRoute('/blytzcollect/analytics')({
  component: BlytzCollectAnalyticsScreen
})
